export const ALERTS_ANIMATED_ICON_MAP = {
  'Air Pollution Warning': 'alertpollution',
  'Air Pollution Watch': 'alertpollution',
  'Air Quality Advisory': 'alertpollution',
  'Air Quality Alert': 'alertpollution',
  'Air Quality Warning': 'alertpollution',
  'Air Quality Watch': 'alertpollution',
  'Air Stagnation Advisory': 'alertpollution',
  'Ashfall Advisory': 'alertash',
  'Ashfall Warning': 'alertash',
  'Blizzard Warning': 'alertsnow',
  'Blizzard Watch': 'alertsnow',
  'Blowing Dust Advisory': 'alertdust',
  'Blowing Dust Warning ': 'alertdust',
  'Coastal Flood Warning': 'alertflood',
  'Coastal Flood Watch': 'alertflood',
  'Dense Fog Advisory': 'alertfog',
  'Dense Smoke Advisory': 'alertsmoke',
  'Dust Storm Advisory ': 'alertdust',
  'Dust Storm Warning': 'alertdust',
  'Excessive Heat Warning': 'alertheat',
  'Excessive Heat Watch': 'alertheat',
  'Extreme Cold Warning': 'alertcold',
  'Extreme Cold Watch': 'alertcold',
  'Flash Flood Watch': 'alertflood',
  'Flood Advisory': 'alertflood',
  'Flood Watch': 'alertflood',
  'Freeze Warning': 'alertfreeze',
  'Freeze Watch': 'alertfreeze',
  'Freezing Fog Advisory': 'alertfog',
  'Freezing Rain Advisory': 'alerticy',
  'Frost Advisory': 'alertfrost',
  'Hard Freeze Warning': 'alertfreeze',
  'Hard Freeze Watch': 'alertfreeze',
  'Heat Advisory': 'alertheat',
  'High Surf Advisory': 'alertflood',
  'High Surf Warning': 'alertflood',
  'High Wind Warning': 'alertwindy',
  'High Wind Watch': 'alertwindy',
  'Hurricane Warning': 'alerthurricane',
  'Hurricane Watch': 'alerthurricane',
  'Hurricane Wind Warning': 'alerthurricane',
  'Hurricane Wind Watch': 'alerthurricane',
  'Ice Storm Warning': 'alerticy',
  'Lake Effect Snow Advisory': 'alertsnow',
  'Lake Effect Snow and Blowing Snow Advisory': 'alertsnow',
  'Lake Effect Snow Warning': 'alertsnow',
  'Lake Effect Snow Watch': 'alertsnow',
  'Lake Wind Advisory': 'alertwindy',
  'Lakeshore Flood Advisory': 'alertflood',
  'Lakeshore Flood Warning': 'alertflood',
  'Lakeshore Flood Watch': 'alertflood',
  'Ozone Action Day (Watch)': 'alertpollution',
  'Ozone Alert': 'alertpollution',
  'Ozone Warning': 'alertpollution',
  'Severe Thunderstorm Watch': 'alerttstorm',
  'Snow Squall Warning': 'alertsnow',
  'Storm Surge Warning': 'alertflood',
  'Storm Surge Watch': 'alertflood',
  'Tornado Watch': 'alerttornado',
  'Tropical Storm Warning': 'alerttropicalstorm',
  'Tropical Storm Watch': 'alerttropicalstorm',
  'Tropical Storm Wind Warning': 'alerttropicalstorm',
  'Tropical Storm Wind Watch': 'alerttropicalstorm',
  'Typhoon Warning': 'alerthurricane',
  'Typhoon Watch': 'alerthurricane',
  'Wind Advisory': 'alertwindy',
  'Wind Chill Advisory': 'alertcold',
  'Wind Chill Warning': 'alertcold',
  'Wind Chill Watch': 'alertcold',
  'Winter Storm Warning': 'alertsnow',
  'Winter Storm Watch': 'alertsnow',
  'Winter Weather Advisory': 'alertsnow',
} as const;
